<div class="cnt-page-internal">
    <div class="row-title">
        <teiasoft-title [title]="'enquiryBook.title' | translate"></teiasoft-title>
    </div>
    <div class="cnt-data">
        <div class="cnt-sx">
            <teiasoft-toolbar [buttonsList]="buttonsListSx" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)" style="border-bottom:.1vh solid #595959;margin-bottom: 1vh;"></teiasoft-toolbar>
            <div class="row-menu-sx" (click)="onSelectStatus('all')">
                <span [ngClass]="{'bold' : statusSelected == 'all'}"><i class="fal fa-angle-right mr-5"></i>All statuses ({{enquiriesList.length}})</span>
            </div>
            <div class="row-menu-sx pl-2" *ngFor="let item of headerParametersValues.mstOfferStatus" (click)="onSelectStatus(item)">
                <span [ngClass]="{'bold' : statusSelected == item}">
                    <i *ngIf="statusSelected != item" class="fal fa-square mr-5"></i><i *ngIf="statusSelected === item" class="fas fa-check-square mr-5"></i>
                    {{item}} ({{countForStatus(item)}})</span>
            </div>
        </div>
        <div class="cnt-dx">
            <teiasoft-toolbar [buttonsList]="buttonsListDx" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)" style="width: 100%;border-bottom:.1vh solid #595959; margin-bottom: 1vh;"></teiasoft-toolbar>
            <!-- ENQUIRIES LIST AND ITEMS PREVIEW PANEL -->
            <div class="cnt-enquiries-items">  
                <div class="cnt-enquiries">
                    <div [id]="'enquiry_' + i" *ngFor="let item of filteredEnquiriesList; let i=index" class="row-enquiry" [ngClass]="{'row-alternate': isEven(i)}" (click)="onSelectEnquiry(item.EnquiryNo, item.OfferStatus, i)">
                        <span class="bold mb-5">{{item.EnquiryNo}} // {{item.CustomerName}}</span>
                        <span class="mb-5">{{item.OrderReason}} // {{item.MstOfferStatus}} // {{item.OfferStatus}}</span>
                        <div class="mb-5">
                            <span innerHtml="{{getIcon('FeasibilityStatus', item)}} {{getIcon('CostsStatus', item)}} {{getIcon('DeliveryStatus', item)}}"></span> <span></span>
                        </div>
                        <span class="span-user">{{item.SalesPerson}} ({{item.SalesOffice}}) // {{item.CreationDate | date: globals.dateTimeFormat}}</span>
                    </div>
                </div>
                <div class="cnt-items" [ngClass]="{'cnt-noaction' : action == ''}">
                    <span *ngIf="action == ''" class="span-noaction">Select an Enquiry or create a new one</span>
                    <app-form-enquiry *ngIf="action != ''" 
                    style="width:100%"
                    [action]="action"
                    [customerList]="headerParametersValues.customers!"
                    [mstOfferStatusList]="mstOfferStatusList"
                    [unitSystemList]="unitSystemList"
                    [salesOfficeList]="salesOfficeList"
                    [smsList]="smsList"
                    [alloySurchargeList]="alloySurchargeList"
                    [orderReasonList]="orderReasonList"
                    [marketFamilyList]="marketFamilyList"
                    [normGradesDataSet]="normGradesDataSet"
                    [rawMaterialGradeList]="rawMaterialGradeList"
                    [enquiryByEnquiryNo]="enquiryByEnquiryNo"
                    ></app-form-enquiry>
                </div>
            </div>
        </div>
    </div>
</div>
